module.exports = __webpack_public_path__ + "static/media/S_simul4.7f307ad0.png";